import React from 'react';
import { Users, BookOpen, Star, Map } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="text-accent" size={24} data-id="element-316" />,
    text: '+500 nutricionistas confían'
  }, {
    icon: <BookOpen className="text-accent" size={24} data-id="element-317" />,
    text: '6+ Tomos + Bonos'
  }, {
    icon: <Star className="text-accent" size={24} data-id="element-318" />,
    text: '4.9/5 calificación ⭐'
  }, {
    icon: <Map className="text-accent" size={24} data-id="element-319" />,
    text: '🇦🇷 Todo el país'
  }];
  return <div className="text-white py-4 border-y border-accent/10" data-id="element-320">
      <div className="max-w-6xl mx-auto px-3" data-id="element-321">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x-0 md:divide-x divide-accent/20" data-id="element-322">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center gap-1" data-id="element-323">
              {stat.icon}
              <span className="font-semibold text-xs md:text-sm" data-id="element-324">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}